// Schema Registry for Serialization System
// Integrates with existing audit structure and regulatory requirements

export const SCHEMAS = {
    User: {
        v1_0_0: {
            required: ["id", "email", "role", "createdAt", "updatedAt"],
            optional: ["firstName", "lastName", "phone", "status", "kycStatus", "preferences"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "banco_espana_aml",
                retentionPeriod: "5_years"
            }
        },
        v1_1_0: {
            required: ["id", "email", "role", "createdAt", "updatedAt", "kycStatus"],
            optional: ["firstName", "lastName", "phone", "status", "preferences", "riskProfile"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "banco_espana_aml",
                retentionPeriod: "5_years"
            }
        }
    },
    
    Opportunity: {
        v1_0_0: {
            required: ["id", "title", "amount", "minimumInvestment", "status", "createdAt"],
            optional: ["description", "location", "propertyType", "riskLevel", "expectedReturn", "duration", "images", "media"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "cnmv_regulations",
                retentionPeriod: "10_years"
            }
        },
        v1_1_0: {
            required: ["id", "title", "amount", "minimumInvestment", "status", "createdAt", "approvedBy"],
            optional: ["description", "location", "propertyType", "riskLevel", "expectedReturn", "duration", "images", "media", "complianceStatus"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "cnmv_regulations",
                retentionPeriod: "10_years"
            }
        }
    },
    
    Investment: {
        v1_0_0: {
            required: ["id", "userId", "opportunityId", "amount", "status", "createdAt"],
            optional: ["expectedReturn", "duration", "paymentMethod", "documents"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "financial_regulations",
                retentionPeriod: "10_years"
            }
        },
        v1_1_0: {
            required: ["id", "userId", "opportunityId", "amount", "status", "createdAt", "complianceCheck"],
            optional: ["expectedReturn", "duration", "paymentMethod", "documents", "riskAssessment"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "financial_regulations",
                retentionPeriod: "10_years"
            }
        }
    },
    
    Transaction: {
        v1_0_0: {
            required: ["id", "userId", "type", "amount", "status", "createdAt"],
            optional: ["investmentId", "opportunityId", "paymentMethod", "reference", "fees"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "financial_regulations",
                retentionPeriod: "10_years"
            }
        }
    },
    
    Activity: {
        v1_0_0: {
            required: ["id", "userId", "action", "timestamp"],
            optional: ["entityType", "entityId", "details", "ipAddress", "userAgent"],
            audit: {
                trackChanges: false, // Activities are immutable
                regulatoryRequirement: "audit_requirements",
                retentionPeriod: "5_years"
            }
        }
    },

    // ===== NUEVOS ESQUEMAS IMPLEMENTADOS =====
    
    Agent: {
        v1_0_0: {
            required: ["id", "nombre", "usuarioId", "tipo", "activo", "fechaCreacion", "actualizadoEn"],
            optional: ["email", "telefono", "especializacion", "zonaGeografica", "isVerified", "opportunitiesCreated", "successfulOperations", "totalManaged", "totalCommissions", "projectsCount", "successfulProjects", "badges", "tier", "ranking", "isAgency", "agencyId", "agencyName", "agencyDescription", "isAgencyOwner"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "agent_regulations",
                retentionPeriod: "7_years"
            }
        },
        v1_1_0: {
            required: ["id", "nombre", "usuarioId", "tipo", "activo", "fechaCreacion", "actualizadoEn", "complianceStatus"],
            optional: ["email", "telefono", "especializacion", "zonaGeografica", "isVerified", "opportunitiesCreated", "successfulOperations", "totalManaged", "totalCommissions", "projectsCount", "successfulProjects", "badges", "tier", "ranking", "isAgency", "agencyId", "agencyName", "agencyDescription", "isAgencyOwner", "riskAssessment", "performanceScore"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "agent_regulations",
                retentionPeriod: "7_years"
            }
        }
    },

    Document: {
        v1_0_0: {
            required: ["id", "userId", "fileName", "fileType", "fileSize", "documentType", "status", "uploadedAt", "updatedAt"],
            optional: ["metadata", "securityLevel", "retentionPeriod", "encryptionKey", "accessControl", "version"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "document_regulations",
                retentionPeriod: "10_years"
            }
        },
        v1_1_0: {
            required: ["id", "userId", "fileName", "fileType", "fileSize", "documentType", "status", "uploadedAt", "updatedAt", "complianceCheck"],
            optional: ["metadata", "securityLevel", "retentionPeriod", "encryptionKey", "accessControl", "version", "validationStatus", "approvedBy", "approvedAt"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "document_regulations",
                retentionPeriod: "10_years"
            }
        }
    },

    KYC: {
        v1_0_0: {
            required: ["userId", "clientType", "status", "submittedAt", "updatedAt"],
            optional: ["personalInfo", "address", "financial", "compliance", "verification", "documents", "reviewedAt", "reviewer", "notes"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "banco_espana_aml",
                retentionPeriod: "5_years"
            }
        },
        v1_1_0: {
            required: ["userId", "clientType", "status", "submittedAt", "updatedAt", "complianceStatus"],
            optional: ["personalInfo", "address", "financial", "compliance", "verification", "documents", "reviewedAt", "reviewer", "notes", "riskLevel", "enhancedDueDiligence", "sanctionsCheck", "fatcaDeclaration", "crsDeclaration"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "banco_espana_aml",
                retentionPeriod: "5_years"
            }
        }
    },

    Notification: {
        v1_0_0: {
            required: ["id", "userId", "message", "date", "read"],
            optional: ["data", "type", "priority", "expiresAt", "actionUrl"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "communication_regulations",
                retentionPeriod: "3_years"
            }
        },
        v1_1_0: {
            required: ["id", "userId", "message", "date", "read", "notificationType"],
            optional: ["data", "type", "priority", "expiresAt", "actionUrl", "deliveryStatus", "readAt", "category"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "communication_regulations",
                retentionPeriod: "3_years"
            }
        }
    },

    Message: {
        v1_0_0: {
            required: ["id", "userId", "userEmail", "text", "createdAt"],
            optional: ["encrypted", "messageType", "recipientId", "status", "readAt"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "communication_regulations",
                retentionPeriod: "3_years"
            }
        },
        v1_1_0: {
            required: ["id", "userId", "userEmail", "text", "createdAt", "messageType"],
            optional: ["encrypted", "recipientId", "status", "readAt", "priority", "category", "attachments", "threadId"],
            audit: {
                trackChanges: true,
                regulatoryRequirement: "communication_regulations",
                retentionPeriod: "3_years"
            }
        }
    }
};

// Schema validation rules
export const VALIDATION_RULES = {
    email: {
        pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
        message: "Invalid email format"
    },
    amount: {
        min: 0,
        message: "Amount must be positive"
    },
    percentage: {
        min: 0,
        max: 100,
        message: "Percentage must be between 0 and 100"
    },
    date: {
        pattern: /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z$/,
        message: "Invalid date format"
    },
    phone: {
        pattern: /^[+]?[1-9][\d]{0,15}$/,
        message: "Invalid phone number format"
    },
    dni: {
        pattern: /^[0-9]{8}[A-Z]$/,
        message: "Invalid DNI format (8 digits + 1 letter)"
    },
    cif: {
        pattern: /^[A-Z][0-9]{8}$/,
        message: "Invalid CIF format (1 letter + 8 digits)"
    }
};

// Migration paths between versions
export const MIGRATION_PATHS = {
    User: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                kycStatus: entity.kycStatus || "pending",
                riskProfile: entity.riskProfile || "medium"
            })
        }
    },
    Opportunity: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                approvedBy: entity.approvedBy || "system",
                complianceStatus: entity.complianceStatus || "pending"
            })
        }
    },
    Investment: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                complianceCheck: entity.complianceCheck || "pending",
                riskAssessment: entity.riskAssessment || "medium"
            })
        }
    },
    Agent: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                complianceStatus: entity.complianceStatus || "pending",
                riskAssessment: entity.riskAssessment || "medium",
                performanceScore: entity.performanceScore || 0
            })
        }
    },
    Document: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                complianceCheck: entity.complianceCheck || "pending",
                validationStatus: entity.validationStatus || "pending",
                approvedBy: entity.approvedBy || null,
                approvedAt: entity.approvedAt || null
            })
        }
    },
    KYC: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                complianceStatus: entity.complianceStatus || "pending",
                riskLevel: entity.riskLevel || "medium",
                enhancedDueDiligence: entity.enhancedDueDiligence || false,
                sanctionsCheck: entity.sanctionsCheck || false,
                fatcaDeclaration: entity.fatcaDeclaration || false,
                crsDeclaration: entity.crsDeclaration || false
            })
        }
    },
    Notification: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                notificationType: entity.notificationType || "general",
                deliveryStatus: entity.deliveryStatus || "sent",
                category: entity.category || "system"
            })
        }
    },
    Message: {
        "v1.0.0": {
            "v1.1.0": (entity) => ({
                ...entity,
                messageType: entity.messageType || "general",
                priority: entity.priority || "normal",
                category: entity.category || "communication",
                threadId: entity.threadId || null
            })
        }
    }
};

// Default versions for each entity type
export const DEFAULT_VERSIONS = {
    User: "v1.1.0",
    Opportunity: "v1.1.0", 
    Investment: "v1.1.0",
    Transaction: "v1.0.0",
    Activity: "v1.0.0",
    Agent: "v1.1.0",
    Document: "v1.1.0",
    KYC: "v1.1.0",
    Notification: "v1.1.0",
    Message: "v1.1.0"
};

// Regulatory compliance mapping
export const REGULATORY_MAPPING = {
    "banco_espana_aml": {
        description: "Banco de España Anti-Money Laundering",
        requirements: ["kyc", "risk_assessment", "transaction_monitoring"],
        retentionPeriod: "5_years"
    },
    "cnmv_regulations": {
        description: "CNMV Investment Services Regulations", 
        requirements: ["opportunity_approval", "risk_disclosure", "investor_protection"],
        retentionPeriod: "10_years"
    },
    "financial_regulations": {
        description: "General Financial Regulations",
        requirements: ["transaction_records", "audit_trail", "compliance_reporting"],
        retentionPeriod: "10_years"
    },
    "audit_requirements": {
        description: "General Audit Requirements",
        requirements: ["activity_logging", "access_control", "data_integrity"],
        retentionPeriod: "5_years"
    },
    "agent_regulations": {
        description: "Agent and Intermediary Regulations",
        requirements: ["agent_licensing", "performance_monitoring", "commission_tracking"],
        retentionPeriod: "7_years"
    },
    "document_regulations": {
        description: "Document Management and Security Regulations",
        requirements: ["document_encryption", "access_control", "retention_policies"],
        retentionPeriod: "10_years"
    },
    "communication_regulations": {
        description: "Communication and Notification Regulations",
        requirements: ["message_encryption", "delivery_confirmation", "retention_policies"],
        retentionPeriod: "3_years"
    }
}; 